import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=be0e6aac&"
import script from "./Pending.vue?vue&type=script&lang=js&"
export * from "./Pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be0e6aac')) {
      api.createRecord('be0e6aac', component.options)
    } else {
      api.reload('be0e6aac', component.options)
    }
    module.hot.accept("./Pending.vue?vue&type=template&id=be0e6aac&", function () {
      api.rerender('be0e6aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Pending/Pending.vue"
export default component.exports